/**
 * Mapeamento de tipos de entidade para suas operações relacionadas
 * Usado para filtrar por tipo de mensagem (ex: "Student" retorna NewStudent + UpdateStudent + DeleteStudent)
 */
export const messageTypeMapping: Record<string, string[]> = {
  'Student': ['NewStudent', 'UpdateStudent', 'DeleteStudent'],
  'Teacher': ['NewTeacher', 'UpdateTeacher', 'DeleteTeacher'],
  'School': ['NewSchool', 'UpdateSchool', 'DeleteSchool'],
  // Class inclui tanto nomenclatura Class (logs) quanto Section (fila)
  'Class': ['NewSection', 'UpdateSection', 'DeleteSection', 'NewClass', 'UpdateClass', 'DeleteClass'],
  'StudentEnrollment': ['NewStudentEnrollment', 'DeleteStudentEnrollment'],
  'TeacherRoster': ['NewTeacherRoster', 'DeleteTeacherRoster'],
  'Staff': ['NewStaff', 'UpdateStaff', 'DeleteStaff'],
  'StaffRoster': ['NewStaffRoster', 'DeleteStaffRoster'],
};

/**
 * Mapeamento de operações Class (frontend) para Section (backend)
 * Backend usa nomenclatura "Section" mas frontend exibe "Turma/Class" para o usuário
 */
export const operationClassToSection: Record<string, string> = {
  'NewClass': 'NewSection',
  'UpdateClass': 'UpdateSection',
  'DeleteClass': 'DeleteSection',
};

/**
 * Mapeamento inverso: Section (backend) para Class (frontend)
 */
export const operationSectionToClass: Record<string, string> = {
  'NewSection': 'NewClass',
  'UpdateSection': 'UpdateClass',
  'DeleteSection': 'DeleteClass',
};

/**
 * Converte operação de Class para Section se necessário
 */
export function normalizeOperation(operation: string): string {
  return operationClassToSection[operation] || operation;
}

/**
 * Verifica se um messageType corresponde ao filtro de tipo selecionado
 */
export function matchesMessageTypeFilter(messageType: string | undefined, filter: string): boolean {
  if (!messageType || !filter) return true;

  const allowedTypes = messageTypeMapping[filter];
  if (!allowedTypes) return true;

  return allowedTypes.includes(messageType);
}
